import {toQueryString} from '@s-ui/js/lib/string'

import FetcherFactory from '../../fetcher/Fetchers/factory.js'
import factoryLogger from '../../logger/index.js'
import NewsMappersFactory from '../../news/Mappers/factory.js'
import {FromRawsAIFaqsToFaqsListVOMapper} from '../../seo/Mappers/FromRawsAIFaqsToFaqsListVOMapper.js'
import VehiclesErrorsFactory from '../Errors/factory.js'
import {VehiclesMappersFactory} from '../Mappers/factory.js'
import VehiclesValueObjectsFactory from '../ValueObjects/factory.js'
import {HTTPVehiclesRepository} from './HTTPVehiclesRepository.js'

export default class VehiclesRepositoriesFactory {
  static httpVehiclesRepository = ({config}) =>
    new HTTPVehiclesRepository({
      config,
      fakeFetcher: FetcherFactory.fakeFetcher({config}),
      fetcher: FetcherFactory.httpFetcher({config}),
      fetchOrFail: FetcherFactory.fetchOrFail({config}),
      log: factoryLogger({prefix: 'HTTPVehicleRepository'}),
      fromRawsAIFaqsToFaqsListVOMapper: FromRawsAIFaqsToFaqsListVOMapper.create({
        config
      }),
      fromNewsDetailResponseToEntityMapper: NewsMappersFactory.fromNewsDetailResponseToEntityMapper({config}),
      fromCompetitorsRawDataToRelatedVehiclesListValueObjectMapper:
        VehiclesMappersFactory.fromCompetitorsRawDataToRelatedVehiclesListValueObjectMapper({config}),
      fromInfoVehicleRawDataToInfoVehicleValueObjectMapper:
        VehiclesMappersFactory.fromInfoVehicleRawDataToInfoVehicleValueObjectMapper({config}),
      fromMarketedMakesRawDataToMarketedMakesValueObjectMapper:
        VehiclesMappersFactory.fromMarketedMakesRawDataToMarketedMakesValueObjectMapper({config}),
      fromModelsHttpRepositoryDataToModelsValueObjectMapper:
        VehiclesMappersFactory.fromModelsHttpRepositoryDataToModelsValueObjectMapper({config}),
      fromMakesRawDataToMakesListValueObjectMapper: VehiclesMappersFactory.fromMakesRawDataToMakesListValueObjectMapper(
        {
          config
        }
      ),
      fromModelsRawDataToModelsListValueObjectMapper:
        VehiclesMappersFactory.fromModelsRawDataToModelsListValueObjectMapper({
          config
        }),
      fromModelVersionsRawDataToModelVersionsVOMapper:
        VehiclesMappersFactory.fromModelVersionsRawDataToModelVersionsVOMapper({
          config
        }),
      fromSearchUrlParamToSearchCodeValueObjectMapper:
        VehiclesMappersFactory.fromSearchUrlParamToSearchCodeValueObjectMapper({
          config
        }),
      fromModelInfoRawDataToModelInfoValueObjectMapper:
        VehiclesMappersFactory.fromModelInfoRawDataToModelInfoValueObjectMapper({config}),
      fromSubscriptionMakesRawDataToMakesListValueObjectMapper:
        VehiclesMappersFactory.fromSubscriptionMakesRawDataToMakesListValueObjectMapper({config}),
      fromSubscriptionModelsRawDataToSubscriptionModelsListValueObjectMapper:
        VehiclesMappersFactory.fromSubscriptionModelsRawDataToSubscriptionModelsListValueObjectMapper({config}),
      fromVersionInfoRawDataToVersionInfoValueObjectMapper:
        VehiclesMappersFactory.fromVersionInfoRawDataToVersionInfoValueObjectMapper({config}),
      fromVehicleInfoRawDataToVehicleInfoValueObjectMapper:
        VehiclesMappersFactory.fromVehicleInfoRawDataToVehicleInfoValueObjectMapper({config}),
      fromVehicleVersionDetailRawDataToVehicleInfoValueObjectMapper:
        VehiclesMappersFactory.fromVehicleVersionDetailRawDataToVehicleInfoValueObjectMapper({config}),
      fromRawDistributorCarouselsToCarouselsInfoVOMapper:
        VehiclesMappersFactory.fromRawDistributorCarouselsToCarouselsInfoVOMapper({config}),
      fromSpecsListRawDataToSpecsListValueObjectMapper:
        VehiclesMappersFactory.fromSpecsListRawDataToSpecsListValueObjectMapper({config}),
      fromSearchToSearchVehiclesRequestValueObjectMapper:
        VehiclesMappersFactory.fromSearchToSearchVehiclesRequestValueObjectMapper({config}),
      fromVehicleListRawDataToVehicleListVOMapper:
        VehiclesMappersFactory.fromVehiclesListRawDataToVehiclesListValueObjectMapper({config}),
      brandModelInfoValueObjectFactory: VehiclesValueObjectsFactory.brandModelInfoValueObject,
      searchVehiclesResultsValueObjectFactory: VehiclesValueObjectsFactory.searchVehiclesResultsValueObject,
      getMarketedMakesVehiclesError: VehiclesErrorsFactory.getMarketedMakesVehiclesError,
      getModelsGroupedByBodyTypeDoorsVehiclesError: VehiclesErrorsFactory.getModelsGroupedByBodyTypeDoorsVehiclesError,
      getModelDetailContentError: VehiclesErrorsFactory.getModelDetailContentError,
      getModelInfoVehiclesError: VehiclesErrorsFactory.getModelInfoVehiclesError,
      getModelDetailContentNotFoundError: VehiclesErrorsFactory.getModelDetailContentNotFoundError,
      getBodyTypeInfoVehiclesError: VehiclesErrorsFactory.getBodyTypeInfoVehiclesError,
      getSubscriptionMakesVehiclesError: VehiclesErrorsFactory.getSubscriptionMakesVehiclesError,
      getSubscriptionMakesNotFoundVehiclesError: VehiclesErrorsFactory.getSubscriptionMakesNotFoundVehiclesError,
      getSubscriptionModelsVehiclesError: VehiclesErrorsFactory.getSubscriptionModelsVehiclesError,
      getSubscriptionModelsNotFoundVehiclesError: VehiclesErrorsFactory.getSubscriptionModelsNotFoundVehiclesError,
      getVersionInfoVehiclesError: VehiclesErrorsFactory.getVersionInfoVehiclesError,
      genericVehiclesErrorFactory: VehiclesErrorsFactory.genericVehiclesErrorFactory,
      notFoundCompetitorsVehiclesErrorFactory: VehiclesErrorsFactory.notFoundCompetitorsVehiclesErrorFactory,
      notFoundVehiclesErrorFactory: VehiclesErrorsFactory.notFoundVehiclesErrorFactory,
      toQueryString
    })
}
